import React, {Component} from 'react';
import {
    BackHandler,
    I18nManager,
    Platform,
    StyleSheet,
    Text,
    View,
    FlatList,
    Image,
    TouchableOpacity,
    KeyboardAvoidingView,
    Alert
} from 'react-native';
import HMModal from "../modal/HMModal";
import Colors from "../../tools/Colors";
import {moderateScale} from "../../tools/Scaling";
import HMTextView from "../HMTextView";
import HMIcon from "../HMIcon";
import HMLabel from "../label/HMLabel";
import * as NavigationService from "../../redux/NavigationService";
import {isBrowser} from "react-device-detect";


var container = null;

export default class HMModalSelectFiles extends Component {

    constructor(props) {
        super(props);
        container = this;
        this.state = {}
    }

    async componentDidMount() {

    }

    componentWillUnmount() {

    }

////////////////////////////////////audio///////////////////////////////


    render() {
        let optional = (Platform.OS === 'ios' ? {
            //compressImageMaxWidth: Platform.OS==='ios'?10000:1000,
            //  compressImageMaxHeight: Platform.OS==='ios'?10000:1000,
            enableRotationGesture: true,
            // cropping: true,
            compressImageQuality: .5
        } : {
            compressImageMaxWidth: 1000,
            compressImageMaxHeight: 1000,
            enableRotationGesture: true,
            cropping: true,
            // compressImageQuality:.5
        });
        const {
            funcSwitch, onPress, styleRoot, style, text, numberOfLines, type, cammas, noFont, listSelectInput,
            onValueChangeSelectInputRoll,
            valueSelectInputRoll,
            indexSelectInputRoll,
            itemSelectInputRoll,
            optionsSelectInputRoll,

            listNameCCTask,
            onValueChangeSelectInputCCTask,
            valueSelectInputCCTask,
            indexSelectInputCCTask,
            itemSelectInputCCTask,
            optionsSelectInputCCTask,

            isVisible,
            hiddenModal,
            _setStateData,
            fileSelect
        } = this.props;
        let checkSeconds = (this.state.currentTime > 0 && this.state.currentTime < 60);
        // let checkBrowser = (Platform.OS == "web" && (navigator.userAgentData && navigator.userAgentData.mobile));
        let checkBrowser = true;
        return (
            <HMModal
                // isVisible={isVisible}
                isVisible={isVisible === 'selectImage' || isVisible === 'selectVideo'}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={hiddenModal}
                onBackButtonPress={hiddenModal}
            >

                <View style={{
                    width: "100%",
                    position: "absolute",
                    bottom: 0,
                    //  height: "90%",
                    borderTopLeftRadius: moderateScale(8),
                    borderTopRightRadius: moderateScale(8),
                    padding: moderateScale(6),
                    backgroundColor: Colors.white
                }}>
                    {
                        isVisible === "selectImage" ?

                            <View>
                                <TouchableOpacity
                                    onPress={() => {
                                    }}
                                    style={{
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        widest: "100%",
                                        backgroundColor: '#eee',
                                        margin: moderateScale(5),
                                        padding: moderateScale(8),
                                        borderRadius: moderateScale(4)
                                    }}>
                                    <View
                                        onPress={() => {
                                        }}
                                        style={{
                                            alignItems: 'center',
                                            backgroundColor: '#eee',
                                            margin: moderateScale(5),
                                            padding: moderateScale(8),
                                            borderRadius: moderateScale(4)
                                        }}>
                                        <View
                                            onPress={() => {
                                            }}
                                            style={{
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#3AABDC',
                                                padding: moderateScale(8),
                                                margin: moderateScale(5),
                                                width: moderateScale(48),
                                                height: moderateScale(48),
                                                borderRadius: moderateScale(24),
                                            }}>

                                            <HMIcon
                                                type={"bold"}
                                                // type={"FontAwesome"}
                                                name="image" style={{
                                                color: Colors.white,
                                                fontSize: moderateScale(28),
                                                padding: moderateScale(2),
                                                alignSelf: "center",
                                                textAlign: "center",
                                            }}/>
                                        </View>


                                        <HMTextView
                                            text={"گرفتن عکس"}
                                            type={'bold'}
                                            style={{
                                                alignSelf: 'center',
                                                //  marginRight: moderateScale(6),
                                                // margin: moderateScale(6),
                                                textAlign: 'center',
                                                color: Colors.colorDarkText,
                                                fontSize: moderateScale(14),
                                            }}/>
                                    </View>
                                    <HMIcon
                                        //  type={"bold"}
                                        type={"Feather"}
                                        name="chevron-left" style={{
                                        color: Colors.white,
                                        fontSize: moderateScale(28),
                                        padding: moderateScale(2),
                                        alignSelf: "center",
                                        textAlign: "center",
                                    }}/>
                                    {
                                        <HMLabel
                                            onClick={() => {
                                                this.setState({
                                                    showMessageInput: false,
                                                })
                                            }}
                                            onChange={(event) => fileSelect(event)}

                                            // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                opacity: .009
                                            }}
                                            type="file" accept="video/*" capture="camera"
                                        />


                                    }
                                </TouchableOpacity>
                                {/*  <TouchableOpacity
                                    onPress={() => {

                                    }}
                                    style={{
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: '#eee',
                                        padding: moderateScale(8),
                                        margin: moderateScale(5),
                                        borderRadius: moderateScale(4)
                                    }}>
                                    <HMTextView
                                        text={"انتخاب عکس از گالری"}
                                        type={'bold'}
                                        style={{
                                            alignSelf: 'center',
                                            //  marginRight: moderateScale(6),
                                            // margin: moderateScale(6),
                                            textAlign: 'center',
                                            color: Colors.colorDarkText,
                                            fontSize: moderateScale(14),
                                        }}/>
                                    {
                                        <HMLabel
                                            onClick={() => {
                                                this.setState({
                                                    showMessageInput: false,
                                                })
                                            }}
                                            onChange={(event) => fileSelect(event)}

                                            // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                opacity: .009
                                            }}
                                            type="file" accept="image/*"
                                        />


                                    }
                                </TouchableOpacity>*/}
                            </View>
                            :
                            <View>
                                <TouchableOpacity
                                    disabled={!checkBrowser}
                                    onPress={() => {

                                        if (checkBrowser) {
                                            _setStateData({visibleModal: ""})
                                            NavigationService.navigateParams("MediaRecorderCapture", {fileSelect})
                                        }


                                    }}
                                    style={{
                                        flexDirection: "row",
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        widest: "100%",
                                        backgroundColor: '#eee',
                                        margin: moderateScale(5),
                                        padding: moderateScale(8),
                                        borderRadius: moderateScale(4)
                                    }}>
                                    <View
                                        onPress={() => {
                                        }}
                                        style={{
                                            flexDirection: "row",
                                            alignItems: 'center',
                                            backgroundColor: '#eee',
                                            margin: moderateScale(5),
                                            padding: moderateScale(8),
                                            borderRadius: moderateScale(4)
                                        }}>
                                        <View
                                            onPress={() => {

                                                //MediaRecorderCapture
                                            }}
                                            style={{
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#3AABDC',
                                                padding: moderateScale(8),
                                                margin: moderateScale(5),
                                                width: moderateScale(48),
                                                height: moderateScale(48),
                                                borderRadius: moderateScale(24),
                                            }}>

                                            <HMIcon
                                                // type={"bold"}
                                                // type={"FontAwesome"}
                                                name="camera" style={{
                                                color: Colors.white,
                                                fontSize: moderateScale(28),
                                                padding: moderateScale(2),
                                                alignSelf: "center",
                                                textAlign: "center",
                                            }}/>
                                        </View>


                                        <HMTextView
                                            text={"گرفتن فیلم"}
                                            type={'bold'}
                                            style={{
                                                alignSelf: 'center',
                                                //  marginRight: moderateScale(6),
                                                marginStart: moderateScale(10),
                                                textAlign: 'center',
                                                color: Colors.colorDarkText,
                                                fontSize: moderateScale(14),
                                            }}/>
                                    </View>
                                    <HMIcon
                                        //  type={"bold"}
                                        type={"Feather"}
                                        name="chevron-left" style={{
                                        color: Colors.blackLight,
                                        fontSize: moderateScale(28),
                                        padding: moderateScale(2),
                                        alignSelf: "center",
                                        textAlign: "center",
                                    }}/>

                                    {
                                        !checkBrowser &&
                                        <HMLabel
                                            onClick={() => {
                                                this.setState({
                                                    showMessageInput: false,
                                                })
                                            }}
                                            onChange={(event) => fileSelect(event, "video")}

                                            // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                opacity: .009
                                            }}
                                            type="file" accept="video/*"
                                            capture="user"
                                            // mode={"record"}

                                        />}


                                </TouchableOpacity>
                                <TouchableOpacity

                                    onPress={() => {
                                    }}
                                    style={{
                                        flexDirection: "row",
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        widest: "100%",
                                        backgroundColor: '#eee',
                                        margin: moderateScale(5),
                                        padding: moderateScale(8),
                                        borderRadius: moderateScale(4)
                                    }}>
                                    <View
                                        onPress={() => {
                                        }}
                                        style={{
                                            flexDirection: "row",
                                            alignItems: 'center',
                                            backgroundColor: '#eee',
                                            margin: moderateScale(5),
                                            padding: moderateScale(8),
                                            borderRadius: moderateScale(4)
                                        }}>
                                        <View
                                            onPress={() => {
                                            }}
                                            style={{
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: '#3AABDC',
                                                padding: moderateScale(8),
                                                margin: moderateScale(5),
                                                width: moderateScale(48),
                                                height: moderateScale(48),
                                                borderRadius: moderateScale(24),
                                            }}>

                                            <HMIcon
                                                // type={"bold"}
                                                // type={"FontAwesome"}
                                                name="image" style={{
                                                color: Colors.white,
                                                fontSize: moderateScale(28),
                                                padding: moderateScale(2),
                                                alignSelf: "center",
                                                textAlign: "center",
                                            }}/>
                                        </View>


                                        <HMTextView
                                            text={"انتخاب فیلم از گالری"}
                                            type={'bold'}
                                            style={{
                                                alignSelf: 'center',
                                                //  marginRight: moderateScale(6),
                                                marginStart: moderateScale(10),
                                                textAlign: 'center',
                                                color: Colors.colorDarkText,
                                                fontSize: moderateScale(14),
                                            }}/>
                                    </View>
                                    <HMIcon
                                        //  type={"bold"}
                                        type={"Feather"}
                                        name="chevron-left" style={{
                                        color: Colors.blackLight,
                                        fontSize: moderateScale(28),
                                        padding: moderateScale(2),
                                        alignSelf: "center",
                                        textAlign: "center",
                                    }}/>
                                    {
                                        <HMLabel
                                            onClick={() => {
                                                this.setState({
                                                    showMessageInput: false,
                                                })
                                            }}
                                            onChange={(event) => fileSelect(event, "video")}

                                            // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                opacity: .009
                                            }}
                                            type="file" accept="video/*"

                                        />


                                    }
                                </TouchableOpacity>
                            </View>
                    }


                </View>
            </HMModal>
        );
    }


}
